import React, { ChangeEventHandler } from "react";
import styles from "./styles/styled-input.module.scss";

type Props = {
  title?: string;
  value?: string;
  placeholder?: string;
  overriddenClass?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  isDisabled?: boolean;
  isValid?: boolean;
  registerField?: any;
  maxlength?: number;
};

const StyledMultilineInput = ({
  title,
  value,
  overriddenClass,
  onChange,
  placeholder,
  isDisabled,
  isValid,
  registerField,
  maxlength,
}: Props) => {
  const validStyle = isValid ? styles.mlt_inp_valid : styles.mlt_inp_invalid;
  const _maxlength = maxlength ? maxlength : 450;

  return (
    <>
      {title && <div className={styles.title}>{title}</div>}
      <div className={styles.inp_container}>
        <textarea
          onChange={onChange}
          value={value}
          className={`${styles.inp_multiline} ${validStyle} ${overriddenClass}`}
          placeholder={placeholder}
          disabled={isDisabled}
          maxLength={_maxlength}
          {...registerField}
        />
        <div className={styles.char_counter}>
          {value?.length ?? 0}/{maxlength}
        </div>
      </div>
    </>
  );
};
export default StyledMultilineInput;
